export const isPWC = (): boolean => {
  return import.meta.env.VITE_ENV === "pwc";
};

export const isMSquaredDemo = (): boolean => {
  return import.meta.env.VITE_ENV === "msquared";
};

export const isMSquared = (): boolean => {
  return import.meta.env.VITE_ENV === "msquared-stage";
};

export const isNeedlStage = (): boolean => {
  return import.meta.env.VITE_ENV === "stage";
};

export const isMSquaredHub = (): boolean => {
  return (import.meta.env.VITE_ENV as string) === "msquared-stage-hub";
};

export const isMSquaredClub = (): boolean => {
  return isMSquaredDemo() || isMSquaredHub();
};

export const isICRA = (): boolean => {
  return import.meta.env.VITE_ENV === "icra-stage";
};

export const isArmada = (): boolean => {
  return import.meta.env.VITE_ENV === "armada";
};

export const isICRAResearchAssist = (): boolean => {
  return import.meta.env.VITE_ENV === "icra-stage-researchassist";
};

export const isICRABranding = (): boolean => {
  return isICRA() || isICRAResearchAssist();
};

export const isNeedl = (): boolean => {
  const env = import.meta.env.VITE_ENV;
  return ["dev", "stage", "production", "qa1"].includes(env);
};

export const isDevEnv = (): boolean => {
  const env = import.meta.env.VITE_ENV;
  return ["dev", "stage"].includes(env);
};

export const isCustomerBrandingEnabled = (): boolean => {
  const env = import.meta.env.VITE_ENV;
  return ["dev", "stage", "production"].includes(env);
};
